const ERROR_KEY = 'ms_auth_error';
const ERROR_TS_KEY = 'ms_auth_error_ts';

/**
 * Сохраняем сообщение об ошибке, чтобы Login.vue мог показать snackbar
 * после redirect/reload.
 */
export function setMsAuthError(message) {
  try {
    sessionStorage.setItem(ERROR_KEY, String(message || 'Microsoft authentication error'));
    sessionStorage.setItem(ERROR_TS_KEY, String(Date.now()));
  } catch (e) {
    // ignore
  }
}

export function readMsAuthError() {
  try {
    const msg = sessionStorage.getItem(ERROR_KEY);
    const ts = sessionStorage.getItem(ERROR_TS_KEY);
    return { msg, ts: ts ? Number(ts) : null };
  } catch (e) {
    return { msg: null, ts: null };
  }
}

export function clearMsAuthError() {
  try {
    sessionStorage.removeItem(ERROR_KEY);
    sessionStorage.removeItem(ERROR_TS_KEY);
  } catch (e) {
    // ignore
  }
}

/**
 * Удобно для Login.vue: прочитать и сразу удалить (чтобы не показывать повторно).
 */
export function popMsAuthError() {
  const { msg } = readMsAuthError();
  if (msg) clearMsAuthError();
  return msg;
}

/**
 * Сбрасывает "залипшую" интеракцию MSAL, которая вызывает
 * BrowserAuthError: interaction_in_progress
 */
export function resetMsalInteractionState() {
  try {
    // самый частый ключ
    sessionStorage.removeItem('msal.interaction.status');

    // чистим msal.* ключи, связанные с интерактивом/authority/state
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith('msal.')) {
        const lk = k.toLowerCase();
        if (
          lk.includes('interaction') ||
          lk.includes('authority') ||
          lk.includes('request') ||
          lk.includes('state') ||
          lk.includes('nonce') ||
          lk.includes('correlation')
        ) {
          keysToRemove.push(k);
        }
      }
    }
    keysToRemove.forEach((k) => sessionStorage.removeItem(k));

    // ваши флаги потока
    sessionStorage.removeItem('ms_login_in_progress');
    sessionStorage.removeItem('start_msal_login');
    sessionStorage.removeItem('msal_login_hint');
  } catch (e) {
    // ignore
  }
}

/**
 * Предварительная проверка authority (openid-configuration).
 */
export async function preflightOpenId(authority) {
  if (!authority) {
    throw new Error('Microsoft authority is not defined');
  }

  const url = authority.replace(/\/+$/, '') + '/v2.0/.well-known/openid-configuration';

  let r;
  try {
    r = await fetch(url, { method: 'GET', cache: 'no-store' });
  } catch (e) {
    throw new Error('Unable to reach Microsoft login service. Network or DNS error.');
  }

  if (!r.ok) {
    let txt = '';
    try {
      txt = await r.text();
      // чтобы не тащить огромные HTML/JSON в snackbar
      if (txt && txt.length > 500) txt = txt.slice(0, 500) + '...';
    } catch (e) {
      // ignore
    }

    throw new Error(`Microsoft OpenID configuration failed (${r.status}). ${txt || ''}`.trim());
  }

  return true;
}
